import { useState, useEffect } from "react";

const useRecorder = () => {
  const [stream, setStream] = useState(null);
  const [recorder, setRecorder] = useState(null);
  const [status, setStatus] = useState("idle");
  const [chunks, setChunks] = useState([]);
  const [blob, setBlob] = useState(null);

  useEffect(() => {
    // const AudioContext = window.AudioContext || window.webkitAudioContext;
    // const audioContext = new AudioContext();
    let stream = null;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(_stream => {
          stream = _stream;
          setStream(stream);
          const mediaRecorder = new MediaRecorder(stream);
          setRecorder(mediaRecorder);
          // window.recorder = mediaRecorder;
          mediaRecorder.ondataavailable = e => {
            // chunks.push(e.data);
            console.log("data available!");
            setChunks(chunks => [...chunks, e.data]);
          };
          // mediaRecorder.onstop = e => {
          //   // console.log("onStop. chunks.length ===", chunks.length);
          //   const blob = new Blob(chunks, { type: "audio/ogg; codecs=opus" });
          //   // window.blob = blob;
          //   setBlob(blob);
          //   const audioURL = window.URL.createObjectURL(blob);
          //   console.log({ audioURL });
          // };
          // const input = audioContext.createMediaStreamSource(stream);
          // const rec = new Recorder(input, {
          //   numChannels: 2,
          // });
        })
        .catch(err => {
          console.log("The following getUserMedia error occured: " + err);
        });
    } else {
      console.log("getUserMedia not supported on your browser!");
    }

    return () => stream && stream.getTracks().forEach(track => track.stop());
  }, []);

  useEffect(() => {
    const blob = new Blob(chunks, { type: "audio/webm; codecs=opus" });
    // window.blob = blob;
    setBlob(blob);
  }, [chunks]);

  const start = () => {
    setChunks([]);
    recorder.start();
    setStatus(recorder.state);
  };

  const stop = () => {
    recorder.stop();
    setStatus(recorder.state);
  };

  return { blob, chunks, start, stop, status };
};

export default useRecorder;
